export default __webpack_public_path__ + "locales/ru/ConvertPasswordDialog.json?hash=2d9dd02c13a4abd06119b15f199b44a0";